"use client";

import { useRouter } from "next/navigation";
import RefundPolicyBody from "@/components/refund/RefundPolicyBody";

const RefundPolicy = () => {
  const router = useRouter();

  return (
    <div className="w-full mt-30">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="max-w-4xl mx-auto w-full">
        <div className="mb-6 flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            className="cursor-pointer"
            onClick={() => router.push("/")}
          >
            <path
              d="M10.4722 2.128C10.1942 1.91179 9.85214 1.7944 9.5 1.7944C9.14787 1.7944 8.80578 1.91179 8.52783 2.128L1.8905 7.28967C1.29517 7.75438 1.62292 8.70834 2.37738 8.70834H3.16667V15.0417C3.16667 15.4616 3.33348 15.8643 3.63041 16.1613C3.92735 16.4582 4.33007 16.625 4.75 16.625H7.91667V11.875C7.91667 11.4551 8.08348 11.0523 8.38042 10.7554C8.67735 10.4585 9.08007 10.2917 9.5 10.2917C9.91993 10.2917 10.3227 10.4585 10.6196 10.7554C10.9165 11.0523 11.0833 11.4551 11.0833 11.875V16.625H14.25C14.6699 16.625 15.0727 16.4582 15.3696 16.1613C15.6665 15.8643 15.8333 15.4616 15.8333 15.0417V8.70834H16.6226C17.3763 8.70834 17.7056 7.75438 17.1095 7.29046L10.4722 2.128Z"
              fill="#686C7A"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
          >
            <path
              opacity="0.6"
              d="M1 0.5L5 4.5L1 8.5"
              stroke="#686C7A"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-sm font-normal text-[#686C7A]">Refund Policy</span>
        </div>

        <RefundPolicyBody />
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
